import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/shared/services/common.service';
import { Constants } from 'src/app/shared/utilities/constants';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  constructor(
    private readonly router: Router,
    private readonly commonService: CommonService
  ) {
    const userData = localStorage.getItem(Constants.STORAGE_KEYS.ID_TOKEN);
    if (userData) {
      this.router.navigateByUrl('/home');
    }
  }

  onLoginClick() {
    this.commonService.loginWithFederation(environment.REDIRECT_URL).subscribe({
      next: (response: any) => {
        if (!response.error && response.data?.redirectUrl) {
          // open the window with the url returned in the response
          window.open(response.data?.redirectUrl, '_self');
        } else if (response?.errors?.length) {
          this.commonService.showErrorMessage(response?.errors[0].errorMessage);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.commonService.showError(error);
      },
    });
  }
}
